import * as types from './types';
import { EmployerSavedFilterSelectionResource } from 'util/resources/EmployerSavedFilterSelection';

export type SavedFilterSelectionsState = {
  savedFilterSelections: EmployerSavedFilterSelectionResource[];
  hasDiff: false;
  loading: boolean;
};

const initialState: SavedFilterSelectionsState = {
  savedFilterSelections: [],
  loading: false,
  hasDiff: false,
};

const savedFilterSelectionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LOAD_TEACHER_SAVED_FILTER_SELECTION_START:
    case types.LOAD_EMPLOYER_SAVED_FILTER_SELECTION_START:
      return { ...state, loading: true };
    case types.LOAD_TEACHER_SAVED_FILTER_SELECTION_SUCCESS:
    case types.LOAD_EMPLOYER_SAVED_FILTER_SELECTION_SUCCESS:
      const hasDiff = (payload as EmployerSavedFilterSelectionResource[]).some(
        (sfs) => sfs.diff?.length > 0,
      );
      const lastViewedFiltersTab = localStorage.getItem('viewed_saved_filters_tab');
      const hasBeenUpdated = (payload as EmployerSavedFilterSelectionResource[]).some((srs) => {
        return (
          !lastViewedFiltersTab || new Date(srs.updatedAt) > new Date(Number(lastViewedFiltersTab))
        );
      });

      return {
        ...state,
        savedFilterSelections: payload as EmployerSavedFilterSelectionResource[],
        loading: false,
        hasDiff: hasDiff && hasBeenUpdated,
      };
    case types.LOAD_TEACHER_SAVED_FILTER_SELECTION_FAILURE:
    case types.LOAD_EMPLOYER_SAVED_FILTER_SELECTION_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default savedFilterSelectionReducer;
